module.exports = __webpack_public_path__ + "e505dfbdc25dd8dd0170efd8bdac0718.png";